<template>
    <div class="features">
        <a name="features"></a>
        <div class="section section-features-3">
            <div class="container">
                <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <div class="phone-container">
                            <img :src="iphone">
                        </div>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <h2 class="title">
                            Почему AkiTorg?
                        </h2>
                        <info-areas
                                info-horizontal
                                icon-color="success"
                                icon="far fa-handshake"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                                Мы не продаём ПО, мы оказываем качественную услугу.
                            </h4>
                            <div
                                    slot="content"
                                    class="description"
                            >
                                <p>
                                    Мы заботимся о том, чтобы у вас ВСЕГДА работало наше приложение. В отличии от всех, мы совсем не ориентированы на продажи. Чем лучше работает нашее ПО, тем дольше вы будете работать с нами.
                                </p>
                            </div>
                        </info-areas>
                        <info-areas
                                info-horizontal
                                icon-color="success"
                                icon="fas fa-user-cog"
                        >
<!--                            <i class="fas fa-user-cog"></i>-->
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                                Техническая поддержка на весь срок использования ПО AkiTorg
                            </h4>
                            <div
                                    slot="content"
                                    class="description"
                            >
                                <p>
                                    По телефону или email наши специалисты и программисты всегда готовы вам помочь. Бесплатный звонок из России по номеру <a href="tel:8-800-222-02-50">8-800-222-02-50</a>.
                                </p>
                            </div>
                        </info-areas>
                        <info-areas
                                info-horizontal
                                icon-color="success"
                                icon="fas fa-piggy-bank"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                                Бесплатная интеграция и тестирование на всех устройствах.
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                                <p>
                                   Мы установим бесплатно приложение за 30 минут практически в любую 1С. Попробуйте и убедитесь на деле.
                                </p>
                            </div>
                        </info-areas>
                    </div>
                </div>
            </div>
            <a name="testimonials"></a>
        </div>
    </div>
</template>

<script>
  import { InfoAreas } from "@/components";

  export default {
    name: "Features",
    components: {
      InfoAreas
    },
    data() {
      return {
        iphone: require("@/assets/img/sections/iphone-min.jpg"),
      };
    },
    computed: {
      features5() {
        return {
          backgroundImage: `url(${this.image})`
        };
      }
    }
  };
</script>

<style lang="scss"></style>